import type {ConnectElementConfig} from '../ConnectElementList';

export const selectedCurrencyParameter = 'selected-currency';

export const AddFundsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "PayoutsEntryPointAddFunds" */
      '../../../components/Payouts/Balance/BalanceBody/BalanceDetailsModal/AddFundsEntryPoint'
    ),
  enabledKey: 'payouts',
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: "Payout component's entry point to add funds",
  friendlyName: 'Payouts entry point: add funds',
  htmlEvents: ['addfundscomplete'],
  htmlAttributes: {
    [selectedCurrencyParameter]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setSelectedCurrency: {
      type: 'AttributeSettingMethod',
      attribute: selectedCurrencyParameter,
      isInternal: true,
      description: 'Set the selected currency',
    },
    setOnAddFundsComplete: {
      type: 'EventListenerMethod',
      event: 'addfundscomplete',
      isInternal: true,
      description: 'Sets the event listener for when the add funds complete',
    },
  },
};
